<div *ngIf="(isLoading$ | async)" class="loading-indicator">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
</div>